import { useWatch } from 'react-hook-form';

export const useMissingFields = (fields: string[]) =>
  useWatch({ name: fields }).filter((v) => !v);
